import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { gsap } from 'gsap';


import image1 from '../assets/gallery/1_gallery.jpg';
import image2 from '../assets/gallery/2_gallery.jpg';
import image3 from '../assets/gallery/3_gallery.jpg';
import image4 from '../assets/gallery/4_gallery.png';
import image5 from '../assets/gallery/5_gallery.jpg';
import image6 from '../assets/gallery/6_gallery.jpg';
import image7 from '../assets/gallery/7_gallery.jpg';
import image8 from '../assets/gallery/8_gallery 2.jpg';
import image9 from '../assets/gallery/9.jpg';

const Gallery = () => {
  const images = [
    {src: image1},
    {src: image6},
    {src: image2},
    {src: image7},
    {src: image3},
    {src: image8},
    {src: image4},
    {src: image9},
    {src: image5},
  ];

  const galleryRef = useRef(null);
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".gallery-hero h1, .gallery-hero p", {
        opacity: 0,
        y: 50,
        duration: 1,
        stagger: 0.2,
      });
    }, heroRef);
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = galleryRef.current.querySelectorAll('.gallery-item');
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div ref={galleryRef}>
      <Helmet>
        <title>Gallery | Commissioned Kilts | Mackintosh's Kilts</title>
        <meta name="description" content="View our collection of commissioned kilts and Highland dress. Each piece reflects our dedication to traditional Scottish kiltmaking and bespoke craftsmanship." />
        <meta name="keywords" content="kilt gallery, commissioned kilts, bespoke kilt examples, Highland dress photos, Scottish tartan gallery, custom kilt showcase" />
        <meta property="og:title" content="Gallery | Commissioned Kilts" />
        <meta property="og:description" content="Explore a selection of our commissioned work, where each piece reflects our dedication to the art of kiltmaking." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.jamesmackintosh.co.uk/gallery" />
        <link rel="canonical" href="https://www.jamesmackintosh.co.uk/gallery" />
      </Helmet>
      <div className="pt-32 pb-8 md:pt-24 md:pb-20 px-4 md:px-8 bg-hero-bg text-center mb-6 md:mb-16" ref={heroRef}>
        <h1 className="font-serif text-3xl md:text-7xl leading-tight mb-4">Gallery</h1>
        <p className="text-xl text-text opacity-80 max-w-3xl mx-auto">Explore a selection of our commissioned work, where each piece reflects our dedication to the art of kiltmaking.</p>
      </div>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {images.map((image, index) => (
            <div className="gallery-item break-inside-avoid rounded-lg overflow-hidden shadow-md opacity-0 translate-y-12 transition-all duration-600 ease-out mb-4" key={index}>
              <div className="relative w-full aspect-[3/4]">
                <img 
                  src={image.src} 
                  alt={`Gallery item ${index + 1}`} 
                  className="absolute inset-0 w-full h-full object-cover transition-all duration-400 ease-in-out lg:grayscale lg:hover:grayscale-0 lg:hover:scale-110"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;